import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { useGetStoreDetailsForOnlineOrder } from "../api/api.get";
import { getCountryPhoneCode } from "../utils/constants";

export interface IOrgContext {
  currency?: string;
  phonePrefix?: string;
}

const OrgContext = createContext<IOrgContext>({
  currency: undefined,
  phonePrefix: undefined,
});

export const useStoreContext = () => useContext(OrgContext);

export default function StoreProvider(props: PropsWithChildren) {
  const { id } = useParams();

  const { data: orgData } = useGetStoreDetailsForOnlineOrder(id);

  const [currency, setCurrency] = useState<string>();
  const [phonePrefix, setPhonePrefix] = useState<string>("+1");

  useEffect(() => {
    if (orgData?.country === "IND") {
      setCurrency("₹");
    } else {
      setCurrency("$");
    }

    setPhonePrefix(getCountryPhoneCode(orgData?.country));
  }, [orgData?.country]);

  return (
    <OrgContext.Provider value={{ currency, phonePrefix }}>
      {props.children}
    </OrgContext.Provider>
  );
}
